module.exports = __webpack_public_path__ + "static/media/map_type_satellite.485d7655.svg";